if (!navigator.userAgent.match(/BlackBerry|BB|PlayBook/i)) {
  if (window.innerWidth >= 1025) {
    window.addEventListener('scroll', throttle(parallax, 14));
    
    function throttle(fn, wait) {
      var time = Date.now();
      return function() {
        if ((time + wait - Date.now()) < 0) {
          fn();
          time = Date.now();
        }
      }
    };
    
    function parallax() {
      let scrolled = window.pageYOffset;
      const parallax = document.querySelectorAll('.parallax');
    
      if (scrolled < 1200) {
        parallax.forEach(el => {
          // let offset = scrolled * -0.15
          // el.style.transform = `translateY(${offset}px)`
          let scale = scrolled * 0.00015
          el.style.transform = `scale(${1 + scale})`
        })
      }
    };
  }
}